import React from "react";
import "./../../styles/pages/AnnouncementPage.css";
import "./../../styles/pages/CustomPage.css";
import concertImage from "../../assets/concierto.jpg";

const AnnouncementPage = () => {
  return (
    <div className="msf-container">
      {/* Fila superior: Texto a la izquierda, imagen a la derecha */}
      <div className="msf-row reverse">
        <div className="msf-text">
          <h2 className="custom-page-h2">
            Concierto solidario en Arahal el 14 de marzo
          </h2>
          <div className="red-line"></div>
          <p>
            La <strong>Asociación Proyecto Chicas Rosas</strong> organiza, en
            colaboración con el <strong>Ayuntamiento de Arahal</strong>, un{" "}
            <strong>Concierto Solidario</strong> para recaudar fondos que serán
            donados a la{" "}
            <strong>Asociación Española contra el Cáncer (AECC)</strong>.
          </p>
          <p>
            <strong className="msf-underline">Fecha:</strong> viernes 14 de
            marzo del 2025 a las 20:00 horas
          </p>
          <p>
            <strong className="msf-underline">Lugar:</strong> Salón de Actos de
            la Casa del Aire, c/ Veracruz, 2, Arahal, Sevilla
          </p>
          <p>
            Actúa el grupo amateur <strong>GRANERO</strong>, formado por seis
            componentes que interpretan música folk-pop en acústico. Bajo el
            título <em>"Música en clave de mujer"</em>, han seleccionado un
            repertorio que deleitará al auditorio.
          </p>
          <p>
            <strong>Objetivos del evento:</strong>
          </p>
          <ul className="announcement-ul">
            <li className="announcement-li">
              Presentar nuestra asociación y ofrecer nuestros servicios.
            </li>
            <li className="announecment-li">
              Sensibilizar sobre la prevención del cáncer de mama.
            </li>
            <li className="announcement-li">
              Destacar la importancia del ejercicio físico para la salud.
            </li>
            <li className="announcement-li">
              Compartir testimonios sobre los beneficios de socializar y
              prevenir secuelas.
            </li>
            <li className="announcement-li">
              Recaudar fondos para la investigación en cáncer de mama.
            </li>
          </ul>
          <p>
            El <strong>donativo para asistir</strong> son 10 euros y el{" "}
            <strong>donativo fila 0</strong> son 5 euros.
          </p>
          <p>
            Si deseas apoyarnos puedes realizar un{" "}
            <strong className="msf-underline">BIZUM</strong> al siguiente
            número:
          </p>
          <p>
            <span className="msf-underline bizum-number">11394</span>
          </p>
          <p>
            <span className="thank-you-message">
              ¡Muchas gracias por tu colaboración!
            </span>
          </p>
        </div>
        <div className="msf-image">
          <img src={concertImage} alt="Evento solidario en Arahal" />
        </div>
      </div>
    </div>
  );
};

export default AnnouncementPage;
